import React from 'react';
import { Hero } from '../components/Hero';
import { CertificationsMarquee } from '../components/CertificationsMarquee';
import { StatsSection } from '../components/StatsSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { NewsletterSection } from '../components/NewsletterSection';

export const Home: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Hero onNavigate={scrollToSection} />
      <CertificationsMarquee />
      <StatsSection />
      <WhyChooseUs />
      <NewsletterSection />
    </>
  );
};
